<template src="./vehiclecheckviewdata.html"></template>
<script>
import Axios from "axios";
import $ from "jquery";
import DeleteImage from "@/pages/operations/deleteimage/deleteimage";
var moment = require("moment");

export default {
  components: { DeleteImage },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
    removenlbr: function (data) {
      const result = data.replaceAll(/(?:\\[rn])+/g, "");
      return result;
    },
  },
  props: ["VehicleCheckSubmitId", "type"],
  data() {
    return {
      ShowLoader: false,
      PopupLoader: false,
      VehicleChecks: [],
      CompanyChecks: [],
      TrailerChecks: "",
      CompanyLogo: "",
      base64_image: "",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      biglightgallery: [],
      trailerbiglightgallery: [],
      ShowFailedCheckModel: false,
      FailedChecks: [],
      SafeNotes: "",
      date_fixed: "",
      VehicleCheckDuration:false
    };
  },
  mounted() {
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    var FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(FleetSubscription.fleet_modules);
    if (
      FleetSubscriptionModules["Hierarchy System"] &&
      (!AccountPermissions.Vehicle ||
        !AccountPermissions["Vehicle Checks"] ||
        !AccountPermissions["Vehicle Checks"]["enable"])
    ) {
      this.$router.push("/");
    }
    document.title = pbx_SiteTitle + " - Vehicles Check View";
    setTimeout(() => {
      this.GetVehicleChecksList();
    }, 800);

    var Company = JSON.parse(localStorage.getItem("Company"));
    if (Company) {
      this.CompanyLogo = Company.logo;
      this.GenerateBase64Logo();
    }
     var CompanySettingsKey = JSON.parse(localStorage.getItem("Company") );
    if(CompanySettingsKey.fleet_settings_key != "undefined"){
      CompanySettingsKey = JSON.parse(CompanySettingsKey.fleet_settings_key);
      if (CompanySettingsKey != null && typeof CompanySettingsKey.VehicleCheckDuration != "undefined" && CompanySettingsKey.VehicleCheckDuration) {
        this.VehicleCheckDuration = CompanySettingsKey.VehicleCheckDuration;
      }
    }   
  },
  methods: {
    GenerateBase64Logo() {
      var obj = {
        token: localStorage.getItem("token"),
        url: this.ImageEndpoint + this.CompanyLogo,
      };
      Axios.post(Endpoints.File.GetBase64Image, obj).then((Response) => {
        if (Response?.data?.success) {
          this.base64_image = Response.data.image_data;
        }
      });
    },
    LoadProfileData() {
      this.GetVehicleChecksList();
    },
    SearchVehicle() {
      this.GetVehicleChecksList();
    },
    GeneratePDF() {
      $("#save_pdf_btn").html("Processing...");
      this.$root.$emit("GeneratePDF");
    },
    GetVehicleChecksList(type = "") {
      var obj = { token: localStorage.getItem("token") };
      obj.vehicleCheckSubmitId = this.VehicleCheckSubmitId;
      this.ShowLoader = true;
      Axios.post(Endpoints.VehicleChecks.VehicleCheckView, obj).then(
        (Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.VehicleChecks = Response.data.FleetCheckSubmit;
            this.CompanyChecks = Response.data.CompanyChecks;

            // ✅ Vehicle Checks
            if (Array.isArray(this.VehicleChecks?.value)) {
              this.VehicleChecks.value.forEach((element) => {
                if (Array.isArray(element.photo) && element.photo.length > 0) {
                  element.photo.forEach((photo) => {
                    this.biglightgallery.push(this.ImageEndpoint + photo);
                  });
                }
              });
            }

            // ✅ Trailer Checks
            this.TrailerChecks = Response.data.FleetTrailerCheckSubmit;

            if (Array.isArray(this.TrailerChecks?.value)) {
              this.TrailerChecks.value.forEach((element) => {
                if (Array.isArray(element.photo) && element.photo.length > 0) {
                  element.photo.forEach((photo) => {
                    this.trailerbiglightgallery.push(this.ImageEndpoint + photo);
                  });
                }
              });
            }
          } else {
            this.$router.push("/error-500");
          }
        }
      );
    },
    MarkSafe() {
        this.ShowFailedCheckModel = true;
        var obj = { token: localStorage.getItem("token") };
        obj.vehicleCheckSubmitId = this.VehicleCheckSubmitId;
        this.ShowLoader = true;
        Axios.post(Endpoints.VehicleChecks.GetVehicleFailedCheck, obj).then((Response) => {
            this.ShowLoader = false;
            if (Response?.data?.success) {
                this.FailedChecks = Response.data.FailedChecks;
            }
        });
    },
    MarkSafeSubmit(){
        if(this.SafeNotes == "") {
            this.$swal("Following Error Found!", "Please Enter Notes", "error").then(() => {});
        }else if(this.date_fixed == "") {
            this.$swal("Following Error Found!", "Please Enter Date Fixed", "error").then(() => {});
        }else{            
            var obj = { token: localStorage.getItem("token") };
            obj.vehicleCheckSubmitId = this.VehicleCheckSubmitId;
            obj.date_fixed = this.date_fixed;
            obj.notes = this.SafeNotes;
            this.PopupLoader = true;
            Axios.post(Endpoints.VehicleChecks.VehicleCheckMarkSafe, obj).then((Response) => {
                this.PopupLoader = false;
                if (Response?.data?.success) {
                    this.VehicleChecks.safe = 1
                    this.ShowFailedCheckModel = false;
                    this.$swal("Vehicle Check Marked Safe Successfully", "", "success").then(() => {
                      window.location.reload();
                    });
                }
            })
        }
    }, 
  },
};
</script>
<style scoped>
.position-relative {
  position: relative;
}
.logomain {
  max-width: 50%;
}
</style>
